module.exports = __webpack_public_path__ + "static/media/who-18.de18a13c.jpg";